import React from 'react'
import { useReactToPrint } from "react-to-print";
import { useRef } from "react";


const EditList = ({receiptList}) => {
  const printRef=useRef(null)
  const print = useReactToPrint ({
    content: () => printRef.current,
  });

  return (
    
    
    <div
    className="modal fade fixed top-0 left-0 hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
    id="exampleModalEdit"
    tabIndex={-1}
    aria-labelledby="exampleModalLabel"
    aria-modal="true"
    role="dialog"
  >
    <div className="modal-dialog modal-lg pointer-events-none relative w-auto">
      <div className="modal-content pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">
        <div className="flex justify-end">
          <svg
            data-bs-dismiss="modal"
            aria-label="Close"
            className="text-primary-blue h-8 w-8"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            role="img"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="m13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29l-4.3 4.29a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0l4.29-4.3l4.29 4.3a1 1 0 0 0 1.42 0a1 1 0 0 0 0-1.42Z"
            />
          </svg>
        </div>
        <div className="modal-header rounded-t-md border-b border-gray-200 p-4">
      {/* {
        receiptList?.map((item,index)=>{
          return(
            <div className="border-primary-blue flex items-center gap-2 border border-t-0 border-r-0 p-2">
            <label htmlFor="" className="text-primary-red font-bold">
              Company Name:
            </label>
            <div className="flex-grow items-center gap-2 lg:flex">

              <input
                type="text"
                // defaultValue=""
                id="company_name"
                value={item.company_name}
                className="border-primary-blue w-full flex-grow border p-2 outline-none"
                placeholder=" company name"
              />
            </div>
          </div>
          )
        })
      } */}

<section ref={printRef} className="mt-10 w-full sm:px-5 md:px-10">
        <div   className="flex w-full max-w-[910px] flex-col gap-2 overflow-hidden border-2 border-green-500 p-2 md:mx-auto">
          <div className="flex items-center justify-between text-lg font-medium text-red-500 sm:text-sm md:text-base">
            <h1>
              Redg. No. :<span className="text-cyan-500">10419/075/076</span>
            </h1>
            <h1>
              Redg. No. :<span className="text-cyan-500">10419/075/076</span>
            </h1>
            <h1>
              Redg. No. :<span className="text-cyan-500">10419/075/076</span>
            </h1>
          </div>
          <div className="flex flex-col items-center justify-center gap-1">
            <h1 className="text-lg font-bold text-red-600 md:text-3xl">
              Graphic Marg Pvt. Ltd.
            </h1>
            <p className="text-lg font-bold text-cyan-600 sm:text-sm md:text-base">
              Bharatpur-11, Bypass Road, Chitwan
            </p>
            <p className="text-lg font-bold text-red-600 sm:text-sm md:text-base">
              Contact No.:
              <span className="text-cyan-600">056-590279, 9855022279</span>
            </p>
          </div>
          <div className="flex flex-col justify-center">
            <div className="flex justify-between text-lg font-semibold text-red-500 sm:text-sm md:text-lg">
              <h1>
                Receipt No. : <span className="text-cyan-500">{receiptList?.id}</span>
              </h1>
              <div className="hidden rounded-tl-xl rounded-br-xl border border-white bg-red-500 py-1 px-2 text-lg text-white shadow-md shadow-black sm:flex sm:text-xl">
                Money Receipt
              </div>
              <h1>
                Date : <span className="text-cyan-500">{receiptList?.received_date}</span>
              </h1>
            </div>
          </div>
          <div className="sm:sm mt-5 flex flex-col gap-1 text-lg font-medium text-red-500 md:text-lg">
            <div>
              Received From (Company Name) :
              <span className="text-cyan-500">{receiptList?.company_name}</span>
            </div>
            <div className="flex gap-5 sm:gap-16">
              <p>
                Address :
                <span className="text-cyan-500">{receiptList?.company_address}</span>
              </p>
              <p>
                PAN No. : <span className="text-cyan-500">{receiptList?.company_pan}</span>
              </p>
            </div>
            {/* <div>
              The Sum of Rupees :<span className="text-cyan-500">{results[0]?.amount ? results[0]?.amount : ""}</span>{" "}
              only.
            </div> */}
            <div>
              By  <span className="text-cyan-500">{receiptList?.payment_mode}</span>  in Payment of Your Account.
            </div>
            <div>Payment Received Details: <span className="text-cyan-500"> {receiptList?.received_details}</span></div>

            {/* Bank payment */}


            {
              receiptList?.payment_mode === "cheque" && <div>
                <div className="flex gap-2">
                  <p className="text-green-500 underline">Cheque Details :</p>
                  <div>
                    Bank Name:
                    <span className="text-cyan-500">{receiptList?.bank_name}</span>
                  </div>
                </div>
                <h1 className="flex gap-5 sm:gap-16">

                  <p>
                    Cheque No. :<span className="text-cyan-500">{receiptList?.cheque_number}</span>
                  </p>
                  <p>
                    Cheque Exchange Date :
                    <span className="text-cyan-500">{receiptList?.check_exchange_date}</span>
                  </p>
                </h1>
              </div>
            }
            {
              receiptList?.payment_mode === "bank" && (  <div className="flex gap-2">
              <p className="text-green-500 underline">Bank Details :</p>
              <div>
                Bank Name:
                <span className="text-cyan-500">{receiptList?.bank_name_1}</span>
              </div>
            </div>)
            }
          

            {
              receiptList?.payment_mode === "e-wallet" && (<div className="flex gap-2">
                <p className="text-green-500 underline"> Esewa Details :</p>
                <div>
                  Esewa Name/Esewa ID :
                  <span className="text-cyan-500">{receiptList?.e_wallet_number}</span>
                </div>
              </div>)
            }

          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center justify-center">
              <div className="flex items-center gap-2 rounded-tl-xl rounded-br-xl border-2 border-red-500 py-1 px-2 text-lg sm:text-xl">
                <p className="rounded-tl-xl rounded-br-xl border-2 border-blue-500 bg-red-500 py-1 px-2 text-lg text-white sm:text-xl">
                  Rs.
                </p>
                <h1 className="rounded-tl-xl rounded-br-xl border-2 border-green-500 py-1 px-2 text-lg text-blue-500 sm:text-xl">
                  <span className="text-green-500">Rs.</span>{ receiptList?.paid_amount}
                </h1>
              </div>
            </div>
            <div className="sm:sm mt-5 flex flex-col gap-1 border-2 border-pink-400 px-3 py-2 text-lg font-medium text-red-500 md:text-lg">
              <h1 className="text-green-500 underline">Payment Giver's</h1>
              <p>
                Name : <span className="text-cyan-500">{receiptList?.payers_name}</span>
              </p>
              <p>
                Contact No. :<span className="text-cyan-500">{receiptList?.payers_contact}</span>
              </p>
              <p>
                Re.With Com. : <span className="text-cyan-500">{receiptList?.relation_with_company}</span>
              </p>
            </div>
            <div className="sm:sm mt-5 flex flex-col gap-1 border-2 border-pink-400 px-3 py-2 text-lg font-medium text-red-500 md:text-lg">
              <h1 className="text-green-500 underline">Payment Receiver's</h1>
              <p>
                Signature :
                <span className="text-cyan-500">........................</span>
              </p>
              <p>
                Name : 
              </p>
              <p>
                Post : 
              </p>
            </div>
          </div>
        </div>
        <div onClick={print} className="flex justify-end">
      <button  className="px-2 mt-0  py-1  bg-primary-blue  rounded-xl text-white">Print </button>
  </div>
      </section>
    
       
        </div>
        
      </div>
    </div>
  </div>    


  )
}

export default EditList